/**
 * Generates a random string for the code verifier
 * @returns {string} A random string between 43 and 128 characters
 */
export const generateCodeVerifier = () => {
  const array = new Uint8Array(32);
  window.crypto.getRandomValues(array);
  return base64URLEncode(array);
};

/**
 * Calculates the SHA-256 hash for the code challenge
 * @param {string} codeVerifier - The code verifier string
 * @returns {Promise<string>} The Base64URL-encoded hash
 */
export const sha256 = async (codeVerifier) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(codeVerifier);
  const hash = await window.crypto.subtle.digest('SHA-256', data);
  return base64URLEncode(new Uint8Array(hash));
};

/**
 * Encodes a Uint8Array to a Base64URL string
 * @param {Uint8Array} buffer - The array to encode
 * @returns {string} The Base64URL-encoded string
 */
const base64URLEncode = (buffer) => {
  const base64 = btoa(String.fromCharCode.apply(null, buffer));
  return base64
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
};

/**
 * Generates a random challenge for the state parameter
 * @returns {string} A random challenge
 */
export const generateStateChallenge = () => {
  const array = new Uint8Array(16);
  window.crypto.getRandomValues(array);
  return base64URLEncode(array);
};
